import gql from "graphql-tag";

const SpecialConditionTypeFragment = gql`
  fragment specialConditionTypeFragment on specialConditionType {
    id
    buildingPart {
      label
    }
    country
    specialConditionTypeCategory {
      id
      label
      specialConditionTypeInputParameter {
        parameter
        specialConditionTypeCategoryId
      }
    }
  }
`;

export default SpecialConditionTypeFragment;
